import styled from 'styled-components';

const DataProtectionStyle = styled.section`
	--titleMarginTop: var(--sp13x);
	--barsWrapMarginTop: var(--sp18x);
	--leftBarPaddingLeft: var(--sp3x);
	--titleMarginBottom: var(--sp4x);
	--contentBlockMarginBottom: var(--sp8x);
	--blockTitleMarginBottom: var(--sp4x);

	margin-top: var(--headerHeight);

	.title {
		margin-top: var(--titleMarginTop);
		word-break: break-all;
	}

	.bars-wrap {
		margin-top: var(--barsWrapMarginTop);

		.sticky-wrap {
			.left-bar {
				position: sticky;
				top: calc(var(--headerHeight) + (var(--headerHeight) / 2));
				padding-left: var(--leftBarPaddingLeft);

				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					height: 100%;
					width: 1px;
					background-color: var(--primaryColor1);
					opacity: 50%;
				}

				.title-clickable {
					cursor: pointer;
					width: fit-content;
					margin-bottom: var(--titleMarginBottom);
					position: relative;

					&.active {
						&::before {
							content: '';
							position: absolute;
							left: calc(var(--leftBarPaddingLeft) * -1);
							top: 0;
							height: 100%;
							width: 3px;
							background-color: var(--primaryColor1);
						}
					}

					&:last-child {
						margin-bottom: unset;
					}
				}
			}
		}

		.right-bar {
			.content-block {
				margin-bottom: var(--contentBlockMarginBottom);

				&:last-child {
					margin-bottom: unset;
				}

				.block-title {
					margin-bottom: var(--blockTitleMarginBottom);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		--titleMarginTop: var(--sp10x);
		--barsWrapMarginTop: var(--sp15x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp6x);
		--blockTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		--titleMarginTop: var(--sp8x);
		--barsWrapMarginTop: var(--sp13x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp6x);
		--blockTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		--titleMarginTop: var(--sp6x);
		--barsWrapMarginTop: var(--sp10x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp5x);
		--blockTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeXS}) {
		--titleMarginTop: var(--sp6x);
		--barsWrapMarginTop: var(--sp10x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp5x);
		--blockTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		--titleMarginTop: var(--sp5x);
		--barsWrapMarginTop: var(--sp5x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp4x);
		--blockTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		--titleMarginTop: var(--sp5x);
		--barsWrapMarginTop: var(--sp5x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp4x);
		--blockTitleMarginBottom: var(--sp3x);

		.right-bar {
			margin-top: var(--sp5x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--titleMarginTop: var(--sp3x);
		--barsWrapMarginTop: var(--sp4x);
		--leftBarPaddingLeft: var(--sp2x);
		--titleMarginBottom: var(--sp2x);
		--contentBlockMarginBottom: var(--sp3x);
		--blockTitleMarginBottom: var(--sp2x);

		.right-bar {
			margin-top: var(--sp4x);
		}
	}
`;

export default DataProtectionStyle;
